import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import MenuPhotography from "./pages/MenuPhotography";
import FoodPhotography from "./pages/FoodPhotography";
import VenuePhotography from "./pages/VenuePhotography";
import BrandPhotography from "./pages/BrandPhotography";
import UberEatsPhotography from "./pages/UberEatsPhotography";
import CafePhotography from "./pages/CafePhotography";
import GoogleBusinessProfilePhotos from "./pages/GoogleBusinessProfilePhotos";
import RestaurantReels from "./pages/RestaurantReels";
import Packages from "./pages/Packages";
import About from "./pages/About";
import Contact from "./pages/Contact";
import GetAQuote from "./pages/GetAQuote";
import AdminLeads from "./pages/AdminLeads";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import StyleGuide from "./pages/StyleGuide";
import MenuShootCostPlanner from "./pages/MenuShootCostPlanner";
import MenuShootPlanner from "./pages/MenuShootPlanner";
import DeliveryAppPhotoAudit from "./pages/DeliveryAppPhotoAudit";
import PhotoNeedsCalculator from "./pages/PhotoNeedsCalculator";
import RestaurantMarketingScore from "./pages/RestaurantMarketingScore";
import LocationsHub from "./pages/LocationsHub";
import SuburbPage from "./pages/SuburbPage";
import CuisinePage from "./pages/CuisinePage";
import BlogHub from "./pages/BlogHub";
import BlogArticle from "./pages/BlogArticle";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />

          {/* Core service pages */}
          <Route path="/menu-photography" element={<MenuPhotography />} />
          <Route path="/menu-photography-melbourne" element={<MenuPhotography />} />
          <Route path="/food-photography" element={<FoodPhotography />} />
          <Route path="/food-photography-melbourne" element={<FoodPhotography />} />
          <Route path="/venue-photography" element={<VenuePhotography />} />
          <Route path="/venue-photography-melbourne" element={<VenuePhotography />} />
          <Route path="/brand-photography" element={<BrandPhotography />} />
          <Route path="/brand-photography-melbourne" element={<BrandPhotography />} />

          {/* Specialised service pages */}
          <Route path="/ubereats-photography" element={<UberEatsPhotography />} />
          <Route path="/uber-eats-photography" element={<UberEatsPhotography />} />
          <Route path="/cafe-photography" element={<CafePhotography />} />
          <Route path="/cafe-photographer-melbourne" element={<CafePhotography />} />
          <Route path="/google-business-profile-photos" element={<GoogleBusinessProfilePhotos />} />
          <Route path="/google-business-photos" element={<GoogleBusinessProfilePhotos />} />
          <Route path="/restaurant-reels" element={<RestaurantReels />} />
          <Route path="/restaurant-reels-melbourne" element={<RestaurantReels />} />

          {/* Process / packages */}
          <Route path="/packages" element={<Packages />} />

          {/* Trust / conversion */}
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/get-a-quote" element={<GetAQuote />} />

          {/* Admin (token-protected, not linked in nav) */}
          <Route path="/admin/leads" element={<AdminLeads />} />

          {/* Phase C — Interactive Tools */}
          <Route path="/menu-shoot-cost-planner" element={<MenuShootCostPlanner />} />
          <Route path="/menu-shoot-planner" element={<MenuShootPlanner />} />
          <Route path="/delivery-app-photo-audit" element={<DeliveryAppPhotoAudit />} />
          <Route path="/photo-needs-calculator" element={<PhotoNeedsCalculator />} />
          <Route path="/restaurant-marketing-score" element={<RestaurantMarketingScore />} />

          {/* Phase D — Locations */}
          <Route path="/locations" element={<LocationsHub />} />
          <Route path="/restaurant-photographer/:suburb" element={<SuburbPage />} />

          {/* Phase E — Cuisine niches */}
          <Route path="/cuisine/:cuisine" element={<CuisinePage />} />

          {/* Phase F — Blog */}
          <Route path="/blog" element={<BlogHub />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />

          {/* Legal */}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms-and-conditions" element={<Terms />} />

          <Route path="/style-guide" element={<StyleGuide />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
